import React from 'react';
import { IconProps } from '../../types/icon';

const SparkleIcon: React.FC<IconProps> = ({ className, size = 24 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M12 2L13.09 8.26L19 9L13.09 9.74L12 16L10.91 9.74L5 9L10.91 8.26L12 2Z" 
        fill="#FFD700"
      />
      <path 
        d="M7 3L7.44 5.11L9.5 5.5L7.44 5.89L7 8L6.56 5.89L4.5 5.5L6.56 5.11L7 3Z" 
        fill="#FFD700"
      />
      <path 
        d="M18 14L18.44 16.11L20.5 16.5L18.44 16.89L18 19L17.56 16.89L15.5 16.5L17.56 16.11L18 14Z" 
        fill="#FFD700"
      />
    </svg>
  );
};

export default SparkleIcon;